<section class="content">
    <div class="container mt-5">
        <div class="row">
            <div class="col-md-10">
                <h3>Email Users</h3>
            </div>
            <div class="col-md-2">
                <button type="button" class="btn btn-outline-primary d-inline" (click)="openGenerateList()">Get User List</button>
            </div>
        </div>
        <div class="row" *ngIf="recipientCount>1000">
            <div class="col">
                <div class="alert alert-warning" role="alert">
                    The amount of recipients included on this email has exceeded the limit of 1000. As a result, it will be automatically split and sent to 1000 recipients at a time, starting from those in the To field, then the CC field, then the BCC field. 
                    All recipients will still receive this email, but they may not see all recipients in the To and CC fields.
                    If you would like to split these emails using a different method, please manually split your list of recipients out to 1000 or less.
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="form-label" for="to">To</label>
                <textarea class="form-control"  rows="3" id="to" name="to" [(ngModel)]="message.to" (keyup)="evaluateRecipientCount()"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="form-label" for="cc">CC</label>
                <textarea class="form-control"  rows="1" id="cc" name="cc" [(ngModel)]="message.cc" (keyup)="evaluateRecipientCount()"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="form-label" for="bcc">BCC</label>
                <textarea class="form-control"  rows="2" id="bcc" name="bcc" [(ngModel)]="message.bcc" (keyup)="evaluateRecipientCount()"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="form-label" for="attachment">Attachment</label>
                <input #attachmentInput type="file" class="form-control" id="attachment" name="attachment" (change)="onFileSelected($event)" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="form-label" for="subject">Subject</label>
                <input class="form-control" id="subject" name="subject" [(ngModel)]="message.subject" (keyup)="evaluateRecipientCount()" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="form-label" for="subject">Message</label>
                <div class="NgxEditor__Wrapper">
                    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
                    <ngx-editor [editor]="editor" [(ngModel)]="message.body" [disabled]="false" [placeholder]="'Type here...'"></ngx-editor>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col text-end mt-3">
                <div *ngIf="recipientCount > 0" class="d-inline">Approximately {{recipientCount}} recipient<span *ngIf="recipientCount>1">s</span> will receive this e-mail.</div>
                <button *ngIf="!sending" type="button" class="btn btn-primary ms-4" [class.disabled]="recipientCount==0" [disabled]="recipientCount==0" (click)="send()">Send</button>
                <button *ngIf="sending" type="button" class="btn btn-primary ms-4 disabled" disabled="disabled">Sending...</button>
            </div>
        </div>
    </div>
</section>
